import { routes } from "./constants";

// Public routes that do not require authentication
export const publicRoutes = [
    routes.login,
    routes.registerOrLogin,
    routes.register,
    routes.forgotPassword,
    routes.resetPassword,
    routes.mockWatchMessaging,
    routes.developerTools,
    routes.pouchDebug,
    routes.pouchDebugMatch,
    routes.refsixMoreIAP,
];

export function isProtectedRoute(pathname: string): boolean {
    return !publicRoutes.some((route) => {
        // Handle exact matches and parameterized routes
        if (route === pathname) return true;

        const hasParams = route.includes(":");
        const routePattern = route.replace(/:[^/]+/g, "[^/]+");
        const regex = new RegExp(`^${routePattern}${hasParams ? "" : "$"}`);
        return regex.test(pathname);
    });
}
